<main class="flex-1 relative z-0 focus:outline-none bg-white">
  <app-header></app-header>
  <router-outlet *ngIf="!(is404Subject | async)"></router-outlet>
  <app-not-found *ngIf="is404Subject | async"></app-not-found>
  <app-footer></app-footer>
</main>
